import {Button} from '@mantine/core';
import React from 'react';

import {useThrowApiExceptionMutation} from 'src/redux/queries/admin';
import {useAlert} from 'src/shared/hooks/useAlert';
import {parseErrorMessage} from 'src/shared/utils/parseErrorMessage';

export const ThrowApiExceptionButton: React.FC = () => {
  const [throwApiException, {isLoading}] = useThrowApiExceptionMutation();
  const {setAlert} = useAlert();

  const handleClick = async () => {
    try {
      await throwApiException().unwrap();
    } catch (error) {
      setAlert(parseErrorMessage(error), 'error');
    }
  };

  return (
    <Button size="sm" onClick={handleClick} loading={isLoading}>
      Throw API Exception
    </Button>
  );
};
